<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" :color="color" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 17.0049C13.5978 16.6742 14 16.0559 14 15.3478C14 14.2913 13.1046 13.4348 12 13.4348C10.8954 13.4348 10 14.2913 10 15.3478C10 16.0559 10.4022 16.6742 11 17.0049V18.6957C11 19.2239 11.4477 19.6522 12 19.6522C12.5523 19.6522 13 19.2239 13 18.6957V17.0049Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33333 9.6087H5.00019C5.02419 4.02337 7.36597 1 12 1C16.6345 1 18.9763 4.0234 18.9998 9.6087H20.6667C21.403 9.6087 22 10.1797 22 10.8841V21.7246C22 22.429 21.403 23 20.6667 23H3.33333C2.59695 23 2 22.429 2 21.7246V10.8841C2 10.1797 2.59695 9.6087 3.33333 9.6087ZM16.9998 9.6087H7.00018C7.02018 4.87561 8.6783 2.73913 12 2.73913C15.3222 2.73913 16.9802 4.87557 16.9998 9.6087ZM4 11.5217V21.087H20V11.5217H4Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'LockIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
